const visiblePropertyIds = [2, 8, 11, 12, 19, 21, 24, 27, 62, 100, 64, 70];

export function hasVisiblePropertyIcons(properties: any[]): boolean {
    return properties && properties.some((p) => visiblePropertyIds.indexOf(p.value) !== -1);
}
